// ponytail: string switch instead of a router dependency — three entry points.
export type Entry = 'admin' | 'webinars' | 'site';

export function entryFor(pathname: string): Entry {
  const path = pathname.replace(/\/+$/, '');
  if (path === '/admin' || path.startsWith('/admin/')) return 'admin';
  if (path === '/webinare' || path.startsWith('/webinare/')) return 'webinars';
  return 'site';
}
